import { render, staticRenderFns } from "./ModelFlattening.vue.html?vue&type=template&id=ddc2adae&lang=html&external"
import script from "./ModelFlattening.vue.js?vue&type=script&lang=js&external"
export * from "./ModelFlattening.vue.js?vue&type=script&lang=js&external"
import style0 from "./ModelFlattening.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports